import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_CA_UQ || "uq.ca.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_CA_UQ || 27535,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_CA_UQ || 27536,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_CA_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_CA_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_CA_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_CA_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: false,
  languages: [LANGUAGE.EN, LANGUAGE.FR],
  countryRegion: "Canada/Eastern",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "EST",
      offset: {
        EST: -5,
        EDT: -4
      }
    },
    [LANGUAGE.FR]: {
      defaultTimezone: "HNE",
      offset: {
        HNE: -5,
        HAE: -4
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<MM>/<DD>/<yyyy>",
    [LANGUAGE.FR]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: true
};

export default _countryEnv;
